export const villesMadagascar = [
    "Antananarivo",
    "Antsirabe",
    "Fianarantsoa",
    "Toamasina",
    "Mahajanga",
    "Toliara",
    "Antsiranana",
    "Ambatondrazaka",
    "Moramanga",
    "Manakara",
    "Mananjary",
    "Farafangana",
    "Vangaindrano",
    "Taolagnaro",
    "Ihosy",
    "Ambalavao",
    "Nosy Be",
    "Sambava",
    "Andapa",
    "Vohemar",
    "Marovoay",
    "Maintirano",
    "Morondava",
    "Belo-sur-Tsiribihina",
    "Miandrivazo",
    "Tsiroanomandidy",
    "Miarinarivo",
    "Soavinandriana",
    "Arivonimamo",
    "Ambositra",
    "Betroka",
    "Amboasary",
    "Ikalamavony",
    "Port-Bergé",
    "Mandritsara",
    "Antsohihy",
    "Bealanana",
    "Analalava",
    "Fenoarivo Atsinanana",
    "Vatomandry",
    "Brickaville",
    "Mahanoro",
    "Toamasina II",
    "Ampasimanolotra",
    "Ambanja",
    "Ambilobe",
    "Antalaha",
    "Marantsetra",
    "Mananara Avaratra",
    "Soanierana Ivongo"
  ];
  